__turbopack_context__.v({
  "cds--inline-loading": "FMjo7a_cds--inline-loading",
  "d-flex": "FMjo7a_d-flex",
  "socialButtons": "FMjo7a_socialButtons",
  "socialSection": "FMjo7a_socialSection",
  "socialSharingGroup": "FMjo7a_socialSharingGroup",
});
